interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
}

export function Sparkline({
  data,
  width = 120,
  height = 32,
}: SparklineProps) {
  if (!data || data.length === 0) {
    return <div className="bg-gray-200 rounded" style={{ width, height }} />;
  }

  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;

  const coords = data.map((value, index) => {
    const x = (index / (data.length - 1 || 1)) * width;
    const y = height - ((value - min) / range) * (height - 4) - 2;
    return { x, y };
  });

  const linePath = `M${coords.map(p => `${p.x},${p.y}`).join(' L')}`;
  const areaPath = `M0,${height} L${coords.map(p => `${p.x},${p.y}`).join(' L')} L${width},${height} Z`;

  return (
    <svg width={width} height={height} style={{ overflow: 'visible' }}>
      <path d={areaPath} fill="#3b82f6" fillOpacity={0.15} />
      <path d={linePath} stroke="#2563eb" strokeWidth="2" fill="none" />
    </svg>
  );
}

export default Sparkline;
